import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  Loading: false,
  LangLoader: false,
};

const LoaderSlice = createSlice({
  name: "Loading",

  initialState,
  reducers: {
    setLoading: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.Loading = payload;
    },
    setLangLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.LangLoader = payload;
    },
    resetLoading: (state: any) => {
      state.Loading = false;
    },
  },
});

export const { setLoading, resetLoading, setLangLoader } = LoaderSlice.actions;

export default LoaderSlice.reducer;
